function versionTuple(value) {
  const match = String(value || '').trim().match(/^(\d+)(?:\.(\d+))?(?:\.(\d+))?/);
  if (!match) return null;
  return [Number(match[1]), Number(match[2] || 0), Number(match[3] || 0)];
}

export function compareConsentVersions(leftVersion, rightVersion) {
  const left = versionTuple(leftVersion);
  const right = versionTuple(rightVersion);
  if (!left || !right) return null;
  for (let index = 0; index < 3; index += 1) {
    if (left[index] !== right[index]) return left[index] > right[index] ? 1 : -1;
  }
  return 0;
}

export function getConsentVersionUpdatePlan(currentVersion, nextVersion) {
  const normalizedCurrent = (currentVersion || '').toString().trim();
  const normalizedNext = (nextVersion || '').toString().trim();

  if (!normalizedNext) {
    return {
      shouldRejectPreviousVersion: false,
      effectiveVersion: normalizedCurrent || null,
    };
  }

  if (!normalizedCurrent) {
    return {
      shouldRejectPreviousVersion: false,
      effectiveVersion: normalizedNext,
    };
  }

  const comparison = compareConsentVersions(normalizedNext, normalizedCurrent);
  // if (normalizedCurrent === normalizedNext) || (comparison !== null && comparison > 0) {
  if (comparison !== null && comparison < 0) {
    return {
      shouldRejectPreviousVersion: false,
      effectiveVersion: normalizedCurrent || null,
      invalid: true,
    };
  }

  if (normalizedCurrent === normalizedNext) {
    return {
      shouldRejectPreviousVersion: false,
      effectiveVersion: normalizedCurrent,
    };
  }

  return {
    shouldRejectPreviousVersion: true,
    effectiveVersion: normalizedNext,
  };
}
